export const CUSTOMIZED_UNAUTHORIZED_STATUS_CODE = 418;
